'use strict';

var novicell = novicell || {};

novicell.keyNumbers = novicell.keyNumbers || new function () {
    this.init = function () {
        const keyNumbers = document.querySelectorAll('.js-key-numbers');

        // return if no keynumbers
        if (!keyNumbers || keyNumbers.length <= 0) {
            return;
        }

        // loop all keynumbers
        for (let i = 0; i < keyNumbers.length; i++) {
            let currentkeyNumber = keyNumbers[i];
            // animate if is visible and not already animated
            if (novicell.helper.isVisible(currentkeyNumber) && !currentkeyNumber.classList.contains('js-key-numbers--animated')) {
                const value = currentkeyNumber.getAttribute('data-number');
                const options = {
                    useEasing: true,
                    useGrouping: true,
                    separator: '.',
                };
                let countUp = new CountUp(currentkeyNumber, 0, value, 0, 2.5, options);

                if (!countUp.error) {
                    countUp.start();
                } else {
                    console.error(countUp.error);
                }
                currentkeyNumber.classList.add('js-key-numbers--animated');                
            }
        }
    };
}();
